import isElectron from 'is-electron';
import { useState } from 'react';
import type { StorageKeys } from '../../utils/storage';
import {
  localStorageGet,
  localStorageSet,
  sessionStorageGet,
  sessionStorageRemove,
} from '../../utils/storage';
import { CookiesPopup } from '../CookiesPopup/CookiesPopup';

export enum CookiesState {
  accepted = 'ACCEPTED',
  declined = 'DECLINED',
}

// Specifying the reuired key that must be moved from session storage to local storage
const MUST_MOVED_KEYS: StorageKeys[] = ['csrf', 'language'];

const moveSessionStorageToLocalStorage = (keys: StorageKeys[]) => {
  keys.forEach(key => {
    const value = sessionStorageGet(key);
    if (value) {
      localStorageSet(key, value);
      sessionStorageRemove(key);
    }
  });
};

export const RequireCookies = ({ children }: { children: JSX.Element }) => {
  const [allowCookies, setAllowCookies] = useState(localStorageGet('allow-cookies'));

  const onAllowCookies = () => {
    localStorageSet('allow-cookies', CookiesState.accepted);
    moveSessionStorageToLocalStorage(MUST_MOVED_KEYS);
    setAllowCookies(CookiesState.accepted);
  };
  const onDeclineCookies = () => {
    localStorageSet('allow-cookies', CookiesState.declined);
    setAllowCookies(CookiesState.declined);
  };

  return (
    <>
      {!isElectron() && !allowCookies && (
        <CookiesPopup onAllowCookies={onAllowCookies} onDeclineCookies={onDeclineCookies} />
      )}
      {children}
    </>
  );
};
